import { ExperienceDto } from "@intelligems/ig-types";
import { DashboardPageName } from "@src/api/types/dashboards";

/**
 * Determines which analytics pages should be available for a given experience
 * in the shared view.
 *
 * For v1, we keep it simple:
 * - Always show base pages: overview, conversion, revenue, discounts, orders, shipping, profit, subscriptions, productGroups
 * - Show customMetrics only if the experience has custom metrics
 * - Never show dataReconciliation (admin-only)
 */
export const getAvailablePages = (
  experience: ExperienceDto
): DashboardPageName[] => {
  const basePages: DashboardPageName[] = [
    "overview",
    "conversion",
    "revenue",
    "discounts",
    "orders",
    "shipping",
    "profit",
    "subscriptions",
    "productGroups",
  ];

  const conditionalPages: DashboardPageName[] = [];

  // Add custom metrics if they exist
  if (
    experience.experienceKeyMetrics?.some((m) => m.experienceCustomMetricId)
  ) {
    conditionalPages.push("customMetrics");
  }

  // Never show dataReconciliation in shared view (admin-only)

  return [...basePages, ...conditionalPages];
};
